/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Monthly.vue?vue&type=template&id=332a1f8a&scoped=true&"
import script from "./Monthly.vue?vue&type=script&setup=true&lang=js&"
export * from "./Monthly.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Monthly.vue?vue&type=style&index=0&id=332a1f8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332a1f8a",
  null
  
)

export default component.exports